import { render, staticRenderFns } from "./CountQuestionComponent.vue?vue&type=template&id=66378107"
import script from "./CountQuestionComponent.vue?vue&type=script&lang=js"
export * from "./CountQuestionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports